import { defineStore } from 'pinia';

import { type CityTagsAdvanced } from '@/shared/models/types';

import { modalStyleSwitcher } from '../lib/modalStyles';

const createEmptySight = (): CityTagsAdvanced => ({});

export const useSightsStore = defineStore('sights', {
  state: () => ({
    sightsIsLoaded: false,
    isOpenDetailsModal: false,
    activeSight: createEmptySight(),
    modalNav: {
      info: true,
      position: true,
      guides: true,
      experience: true,
    },
    navIsLoading: false,
  }),
  actions: {
    useSight(sight: CityTagsAdvanced) {
      this.isOpenDetailsModal = true;
      this.activeSight = sight;

      modalStyleSwitcher(true);
    },
    closeModalDetails() {
      this.isOpenDetailsModal = false;

      modalStyleSwitcher(false);
    },
  },
});
